/**
 * Извлекает понятное сообщение об ошибке из ответа API или сетевого сбоя.
 */
export function getApiErrorMessage(err, fallback = "Что-то пошло не так") {
  if (!err) return fallback;

  if (err.userMessage) return String(err.userMessage);

  const data = err.response?.data;
  if (typeof data === "string" && data.trim()) return data.trim();
  if (data?.error) return String(data.error);
  if (data?.message) return String(data.message);

  const status = err.response?.status;
  if (status === 401) {
    const code = data?.code;
    if (code === "token_expired") return "Сессия истекла — войдите снова";
    if (code === "invalid_credentials") return "Неверный email или пароль";
    return "Требуется вход в аккаунт";
  }
  if (status === 402) {
    return (
      data?.error ||
      data?.message ||
      "Подписка неактивна. Оплатите тариф, чтобы вносить изменения."
    );
  }
  if (status === 403) return data?.error || data?.message || "Доступ запрещён";
  if (status === 404) return data?.error || data?.message || "Не найдено";
  if (status === 409) return data?.error || data?.message || "Такая запись уже существует";
  if (status >= 500) return data?.error || data?.message || "Ошибка сервера. Попробуйте позже";

  if (err.code === "ECONNABORTED" || err.message?.includes("timeout")) {
    return "Превышено время ожидания. Проверьте соединение";
  }
  if (!err.response) {
    return "Нет соединения с сервером. Проверьте интернет";
  }

  if (err.message && !err.message.startsWith("Request failed")) {
    return err.message;
  }

  return fallback;
}

export function attachApiErrorMessage(error) {
  if (error && typeof error === "object") {
    error.userMessage = getApiErrorMessage(error);
  }
  return error;
}
